import {
  CURRENT_TIME_ZONE,
  formatDate,
  formatDateTime,
} from '~publish/helpers/dateFormatters'

const ONE_MINUTE_MS = 60 * 1000
const ONE_HOUR_MS = 60 * ONE_MINUTE_MS
const ONE_DAY_MS = 24 * ONE_HOUR_MS

type FormattedNoteTimestamp = {
  label: string
  title: string
}

export const formatNoteTimestamp = (
  dateTime: string,
  now = new Date(),
  timeZone = CURRENT_TIME_ZONE,
): FormattedNoteTimestamp => {
  const date = new Date(dateTime)
  const elapsedMs = now.getTime() - date.getTime()
  const title = formatDateTime(dateTime, {
    dateFormat: 'MMM d, yyyy,',
    includeTimeZone: true,
    timeFormat: '12',
    timeZone,
  })

  if (elapsedMs >= 0 && elapsedMs < ONE_DAY_MS) {
    if (elapsedMs < ONE_MINUTE_MS) {
      return { label: 'now', title }
    }

    if (elapsedMs < ONE_HOUR_MS) {
      return {
        label: `${Math.floor(elapsedMs / ONE_MINUTE_MS)} min ago`,
        title,
      }
    }

    return {
      label: `${Math.floor(elapsedMs / ONE_HOUR_MS)} hr ago`,
      title,
    }
  }

  return {
    label: formatDate(dateTime, {
      dateFormat: 'MMM d, yyyy',
      includeTimeZone: false,
      timeZone,
    }),
    title,
  }
}
